import { FC } from "react";
import { ModalDialog } from "@rothoblaas/design-system";
import useI18n from "../../hooks/useTranslations";
import { ProjectLight } from "../../http/types/projects";
import { AdminProjectForm } from "./ProjectForm";

interface AdminProjectModalProps {
  onClose: () => void;
  onSuccess?: (project?: ProjectLight) => void;
}

const AdminProjectModal: FC<AdminProjectModalProps> = ({ onClose, onSuccess }) => {
  const i18n = useI18n();

  return (
    <>
      <ModalDialog onClose={onClose} title={i18n.translation.projects.createNew}>
        <AdminProjectForm disableNavigationOnSuccess onSuccess={onSuccess} onClose={onClose} />
      </ModalDialog>
    </>
  );
};

export default AdminProjectModal;
